import Vue from 'vue';
import {isArray} from "bootstrap-vue/es/utils/array";

const state = {
    data: [],
    status: {
        1: 'Inicio de obras',
        2: 'Avance de obras',
        3: 'Término de obra gruesa',
        4: 'Terminaciones',
        5: 'Próxima entrega', // TODO: Disponible para escrituración
        6: 'Entregado'
    }
};

const getters = {
    getEntries(state) {
        return state.data;
    },
    getSelectableStatus(state) {
        const listItem = [];
        Object.keys(state.status).forEach((key) => {
            listItem.push({value: key, label: `${key}. ${state.status[key]}`});
        });
        return listItem;
    }
};

const mutations = {
    SET_DATA(state, houses) {
        state.data = houses;
    }
};

const actions = {

    setEntry: function ({dispatch, commit}) {
        commit('SET_DATA', {
            images: [],
            documents: [],
        });
    },

    loadEntries: function ({dispatch, commit}, postID = 0) {

        const ID = postID || '';
        const token = this.state.login.user.token;

        Vue.prototype.$Api().defaults.headers.common["Authorization"] = `Bearer ${token}`;

        return new Promise((resolve, reject) => {

            Vue.prototype.$Api().get("/wp/v2/houses/" + ID)
                .then(({data}) => {

                    let lotHouses = [];

                    if (data instanceof Array) {

                        data.forEach((lot) => {

                            lotHouses.push({
                                id: lot.id,
                                title: lot.title.rendered,
                                images: lot.acf.images.length,
                                video: lot.acf.video,
                            })

                        });

                    } else {

                        lotHouses = {
                            id: data.id,
                            title: data.title.rendered,

                            place: data.acf.place,
                            condo: data.acf.condo,
                            model: data.acf.model,
                            bathrooms: data.acf.bathrooms,
                            bedrooms: data.acf.bedrooms,
                            surface_house: data.acf.surface_house,
                            surface_terrain: data.acf.surface_terrain,

                            client: {
                                value: data.acf.client.ID,
                                label: `${data.acf.client.user_firstname} ${data.acf.client.user_lastname}`
                            },

                            house: data.acf.house,
                            stage: {
                                value: data.acf.stage.ID,
                                label: data.acf.stage.post_title,
                            },
                            status: {
                                value: data.acf.status.value,
                                label: `${data.acf.status.value}. ${data.acf.status.label}`,
                            },
                            lot: {
                                value: data.acf.lot.ID,
                                label: data.acf.lot.post_title,
                            },
                            address: data.acf.address,
                            delivery_date: data.acf.delivery_date,
                            price_uf: data.acf.price_uf,
                            booking_uf: data.acf.booking_uf,
                            downpayment_uf: data.acf.downpayment_uf,

                            images: data.acf.images || [],
                            documents: data.acf.documents || [],
                            video: data.acf.video,

                            tasks: data.acf.tasks,
                        }

                    }

                    commit('SET_DATA', lotHouses);
                    resolve();

                })
                .catch((response) => {
                    const code = response.response.data.code;
                    const httpCode = response.response.data.data.status;
                    console.log(httpCode, code);
                    reject();
                });

        });

    },

    updateEntry({dispatch, commit, state}) {

        const logData = Object.assign({}, state.data);

        logData.delivery_date = Vue.moment(logData.delivery_date).format('YYYYMMDD');

        const houseData = logData;

        const ID = houseData.id || '';

        // debugger;

        const images = [];

        if (Array.isArray(houseData.images) && houseData.images.length > 0) {
            houseData.images.forEach((item) => {
                images.push(item.ID);
            });
        }

        const documents = [];

        if (Array.isArray(houseData.documents) && houseData.documents.length > 0) {
            houseData.documents.forEach((item) => {
                documents.push({file: item.file.ID, title: item.title})
            });
        }

        const params = {
            title: houseData.house,
            fields: {
                house: houseData.house,
                client: houseData.client.value,
                lot: houseData.lot.value,
                stage: houseData.stage.value,
                status: houseData.status.value,
                address: houseData.address,
                delivery_date: houseData.delivery_date,
                price_uf: houseData.price_uf,
                booking_uf: houseData.booking_uf,
                downpayment_uf: houseData.downpayment_uf,
                // status: houseData.status,
                place: houseData.place,
                condo: houseData.condo,
                model: houseData.model,
                bedrooms: houseData.bedrooms,
                bathrooms: houseData.bathrooms,
                surface_house: houseData.surface_house,
                surface_terrain: houseData.surface_terrain,
                video: houseData.video,
                images: images,
                documents: documents
            },
            status: 'publish'
        };

        const token = this.state.login.user.token;

        Vue.prototype.$Api().defaults.headers.common["Authorization"] = `Bearer ${token}`;

        return new Promise((resolve, reject) => {

            Vue.prototype.$Api().post("/wp/v2/houses/" + ID || '', params)
                .then((response) => {
                    resolve();
                })
                .catch((response) => {
                    const code = response.response.data.code;
                    const httpCode = response.response.data.data.status;
                    console.log(httpCode, code);
                    reject();
                });

        });

    },

    deleteSingleHouse({dispatch, commit, state}) {

        const houseId = state.data.id;
        const params = {
            force: false
        };

        const token = this.state.login.user.token;

        Vue.prototype.$Api().defaults.headers.common["Authorization"] = `Bearer ${token}`;

        return new Promise((resolve, reject) => {

            Vue.prototype.$Api().delete("/wp/v2/houses/" + houseId, {params})
                .then((response) => {
                    resolve();
                })
                .catch((response) => {
                    const code = response.response.data.code;
                    const httpCode = response.response.data.data.status;
                    console.log(httpCode, code);
                    reject();
                });

        })

    }

};

export const houses = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};